import { render } from "./RiskWidget.vue?vue&type=template&id=59528357&scoped=true&ts=true"
import script from "./RiskWidget.vue?vue&type=script&lang=ts"
export * from "./RiskWidget.vue?vue&type=script&lang=ts"

import "./RiskWidget.vue?vue&type=style&index=0&id=59528357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59528357"]])

export default __exports__